function initializeContactForm() {
  const contactForm = document.getElementById("contactForm");
  if (!contactForm) {
    return;
  }

  const formWrapper = contactForm.closest(".contact-us-form");
  let formMessagesDiv = formWrapper
    ? formWrapper.querySelector(".form-messages-container")
    : null;
  if (!formMessagesDiv && formWrapper) {
    formMessagesDiv = document.createElement("div");
    formMessagesDiv.className = "form-messages-container";
    formWrapper.insertBefore(formMessagesDiv, contactForm);
  }

  let overlay = formWrapper
    ? formWrapper.querySelector(".form-loading-overlay")
    : null;
  if (!overlay && formWrapper) {
    overlay = document.createElement("div");
    overlay.className = "contact-form-loading-overlay";
    overlay.style.display = "none";
    overlay.innerHTML = '<div class="loading-spinner"></div>';
    formWrapper.style.position = "relative";
    formWrapper.appendChild(overlay);
  }

  contactForm.addEventListener("submit", function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (formMessagesDiv) formMessagesDiv.innerHTML = "";

    const nameInput = contactForm.querySelector("#name");
    const emailInput = contactForm.querySelector("#email");
    let isValid = true;

    if (!nameInput.value.trim()) {
      displayMessage("Lütfen adınızı girin.", "error", nameInput);
      isValid = false;
    }

    if (!emailInput.value.trim() || !isValidEmail(emailInput.value.trim())) {
      displayMessage(
        "Lütfen geçerli bir e-posta adresi girin.",
        "error",
        emailInput
      );
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    const formData = new FormData(contactForm);

    if (overlay) overlay.style.display = "flex";
    disableForm(true);

    const submitButton = contactForm.querySelector('button[type="submit"]');
    const originalButtonText = submitButton.textContent;
    submitButton.textContent = "Gönderiliyor...";

    fetch(window.themeVariables?.ajaxUrl || "/wp-admin/admin-ajax.php", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          if (formWrapper && contactForm) {
            contactForm.style.display = "none";
            const successMsgElement = document.createElement("div");
            successMsgElement.className = "tapbau-form-message-success";
            const successText =
              window.themeVariables?.contactFormSuccessMsg ||
              data.data?.message ||
              "Mesajınız başarıyla gönderildi!";
            successMsgElement.innerHTML = `<p>${successText}</p>`;
            if (formMessagesDiv) formMessagesDiv.appendChild(successMsgElement);
          }
        } else {
          const isGeneralError = !data.data.field;
          displayMessage(
            data.data.message ||
              window.themeVariables?.contactFormErrorMsg ||
              "Bir hata oluştu. Lütfen tekrar deneyin.",
            "error",
            data.data.field
              ? contactForm.querySelector(`#${data.data.field}`)
              : null,
            isGeneralError
          );
          disableForm(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        let errorMessage =
          window.themeVariables?.contactFormErrorMsg ||
          "Beklenmedik bir hata oluştu. Lütfen daha sonra tekrar deneyin.";
        displayMessage(errorMessage, "error", null, true);
        disableForm(false);
      })
      .finally(() => {
        if (overlay) overlay.style.display = "none";
        if (contactForm.style.display !== "none") {
          submitButton.textContent = originalButtonText;
          disableForm(false); // Also re-enable the form in finally block
        }
      });
  });

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function displayMessage(
    message,
    type,
    fieldToFocus = null,
    isGeneralTopError = false
  ) {
    if (!formMessagesDiv) return;
    const messageDiv = document.createElement("div");
    let messageClasses = "tapbau-form-message";

    if (type === "success") {
      messageClasses += " tapbau-form-message-success";
    } else if (type === "error") {
      messageClasses += isGeneralTopError
        ? " tapbau-form-top-error"
        : " tapbau-form-message-error";
    }
    messageDiv.className = messageClasses;
    messageDiv.innerHTML = message;
    formMessagesDiv.appendChild(messageDiv);

    if (fieldToFocus) {
      fieldToFocus.focus();
      fieldToFocus.classList.add("is-invalid");
    }
  }

  function disableForm(isDisabled) {
    const elements = contactForm.elements;
    for (let i = 0; i < elements.length; i++) {
      elements[i].disabled = isDisabled;
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeContactForm);
} else {
  initializeContactForm();
}
